/**
 * Sync instrumentation helper.
 *
 * NOTE: The global sync lock + singleton registry were rolled back after
 * causing production regressions (items printed but disappearing from
 * orders due to lock contention and cache divergence cleanup races).
 * Each sync hook now uses its own in-instance ref guard, as before.
 *
 * Only the discard logger is kept — it's pure instrumentation, no
 * behavior change.
 */

export async function logSyncDiscard(params: {
  restaurantId: string | null | undefined;
  reason: string;
  table?: string;
  operation?: string;
  recordId?: string;
  orderId?: string;
  attempts?: number;
  errorMessage?: string;
  payload?: unknown;
}): Promise<void> {
  try {
    if (!params.restaurantId) return;
    const { supabase } = await import('@/integrations/supabase/client');
    await supabase.from('error_logs').insert([{
      restaurant_id: params.restaurantId,
      source: 'sync_discard',
      error_code: params.reason,
      error_message: params.errorMessage || params.reason,
      context: {
        table: params.table ?? null,
        operation: params.operation ?? null,
        record_id: params.recordId ?? null,
        order_id: params.orderId ?? null,
        attempts: params.attempts ?? null,
        payload: params.payload ?? null,
        captured_at: new Date().toISOString(),
      } as any,
    }]);
  } catch (e) {
    console.warn('[sync-lock] Failed to log sync_discard (non-blocking):', e);
  }
}